/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Still_Happy_Panda_BlowInputs */

const en_still_happy_panda_blow = /** @type {(inputs: Still_Happy_Panda_BlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receive Surveys`)
};

const de_still_happy_panda_blow = /** @type {(inputs: Still_Happy_Panda_BlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Befragungen erhalten`)
};

/**
* | output |
* | --- |
* | "Receive Surveys" |
*
* @param {Still_Happy_Panda_BlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const still_happy_panda_blow = /** @type {((inputs?: Still_Happy_Panda_BlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Still_Happy_Panda_BlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_still_happy_panda_blow(inputs)
	return de_still_happy_panda_blow(inputs)
});